import { PointsToOmni } from '@/src/experiences'

export default PointsToOmni.Screens.PointsTransferScreen
